<template>
  <v-select
    v-bind="$attrs"
    :value="modelValue"
    @input="handleInput"
    :disabled="!clienteId"
    :items="items"
    item-value="id"
    item-text="linhas[0]"
    return-object
  >
    <template #item="{ on, attrs, item }">
      <v-list-item v-on="on" v-bind="attrs">
        <v-list-item-content>
          <v-list-item-title>
            {{ item.linhas[0] }}
          </v-list-item-title>
          <v-list-item-title>
            {{ item.linhas[1] }}
          </v-list-item-title>
          <v-list-item-title>
            {{ item.linhas[2] }}
          </v-list-item-title>
          <v-list-item-title>
            {{ item.linhas[3] }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </template>
  </v-select>
</template>

<script>
import { indexClientAddresses } from "@/services/clients.js";

export default {
  mixins: [],

  components: {},

  props: {
    modelValue: Object,
    clienteId: Number
  },

  model: {
    prop: "modelValue",
    event: "update:modelValue"
  },

  data() {
    return {
      loading: false,
      items: []
    };
  },

  methods: {
    async loadAddresses() {
      if (!this.clienteId) {
        return;
      }

      this.loading = true;

      try {
        this.items = await indexClientAddresses(this.clienteId);
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },

    handleInput(value) {
      this.$emit("update:modelValue", value);
    }
  },

  computed: {},

  watch: {
    clienteId(value) {
      this.handleInput(null);
      this.loadAddresses();
    }
  }
};
</script>
